// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 手绘模态框样式 */

/* 背景遮罩 */
.DrawingModal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: DrawingModal-fadeIn 0.2s ease-out;
  /* 阻止事件穿透到背后的画布 */
  pointer-events: auto;
  touch-action: none;
}

@keyframes DrawingModal-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 模态框容器 */
.DrawingModal-container {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: DrawingModal-slideUp 0.3s ease-out;
  /* 确保容器捕获所有事件 */
  pointer-events: auto;
  touch-action: auto;
}

@keyframes DrawingModal-slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 标题栏 */
.DrawingModal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 2px solid #e9ecef;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px 12px 0 0;
}

.DrawingModal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}

.DrawingModal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-size: 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.DrawingModal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* 工具栏 */
.DrawingModal-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  flex-wrap: wrap;
  gap: 12px;
}

.DrawingModal-toolbar-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.DrawingModal-toolbar-right {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* 工具组 */
.DrawingModal-tool-group {
  display: flex;
  gap: 8px;
}

.DrawingModal-tool-btn {
  padding: 8px 16px;
  border: 2px solid #dee2e6;
  background: #ffffff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.DrawingModal-tool-btn:hover {
  border-color: #667eea;
  background: #f0f4ff;
  transform: translateY(-1px);
}

.DrawingModal-tool-btn-active {
  border-color: #667eea;
  background: #667eea;
  color: white;
}

/* 滑块组 */
.DrawingModal-slider-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 150px;
}

.DrawingModal-label {
  font-size: 12px;
  font-weight: 600;
  color: #495057;
}

.DrawingModal-slider {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: #e9ecef;
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

.DrawingModal-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #667eea;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.DrawingModal-slider::-webkit-slider-thumb:hover {
  background: #5568d3;
  transform: scale(1.2);
}

.DrawingModal-slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #667eea;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.DrawingModal-slider::-moz-range-thumb:hover {
  background: #5568d3;
  transform: scale(1.2);
}

/* 操作按钮 */
.DrawingModal-action-btn {
  padding: 8px 14px;
  border: none;
  background: #6c757d;
  color: white;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.DrawingModal-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.DrawingModal-action-btn-danger {
  background: #dc3545;
}

.DrawingModal-action-btn-danger:hover {
  background: #c82333;
}

.DrawingModal-action-btn-success {
  background: #28a745;
}

.DrawingModal-action-btn-success:hover {
  background: #218838;
}

/* 颜色栏 */
.DrawingModal-color-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  background: #ffffff;
  border-bottom: 1px solid #e9ecef;
  flex-wrap: wrap;
}

.DrawingModal-color-label {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
}

.DrawingModal-color-picker {
  width: 50px;
  height: 32px;
  border: 2px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.DrawingModal-color-picker:hover {
  border-color: #667eea;
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);
}

/* 预设颜色 */
.DrawingModal-preset-colors {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.DrawingModal-preset-color {
  width: 28px;
  height: 28px;
  border: 2px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.DrawingModal-preset-color:hover {
  transform: scale(1.15);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.DrawingModal-preset-color-active {
  border-color: #667eea !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);
  transform: scale(1.1);
}

/* 画布容器 */
.DrawingModal-canvas-wrapper {
  padding: 24px;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  flex: 1;
  /* 确保画布区域可以正常绘制 */
  pointer-events: auto;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.DrawingModal-canvas-container {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
}

.DrawingModal-text-capture {
  position: absolute;
  inset: 0;
  cursor: text;
  background: transparent;
  z-index: 10;
}

.DrawingModal-text-annotation {
  position: absolute;
  cursor: text;
  font-weight: 600;
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 90%;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  pointer-events: auto;
  z-index: 20;
}

.DrawingModal-text-annotation:hover {
  text-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
}

.DrawingModal-text-input {
  position: absolute;
  min-width: 140px;
  max-width: 90%;
  min-height: 40px;
  padding: 8px 10px;
  border: 2px solid rgba(102, 126, 234, 0.6);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  outline: none;
  resize: none;
  line-height: 1.4;
  box-shadow: 0 6px 18px rgba(102, 126, 234, 0.25);
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  z-index: 30;
}

.DrawingModal-text-input::placeholder {
  color: rgba(73, 80, 87, 0.6);
}

/* 底部按钮栏 */
.DrawingModal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 2px solid #e9ecef;
  background: #ffffff;
  border-radius: 0 0 12px 12px;
  justify-content: flex-end;
}

.DrawingModal-btn {
  padding: 12px 28px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.DrawingModal-btn-cancel {
  background: #e9ecef;
  color: #495057;
}

.DrawingModal-btn-cancel:hover {
  background: #dee2e6;
  transform: translateY(-1px);
}

.DrawingModal-btn-save {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.DrawingModal-btn-save:hover {
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .DrawingModal-container {
    max-width: 95vw;
    max-height: 95vh;
  }

  .DrawingModal-header {
    padding: 16px 20px;
  }

  .DrawingModal-title {
    font-size: 18px;
  }

  .DrawingModal-toolbar {
    padding: 12px 20px;
    flex-direction: column;
    align-items: stretch;
  }

  .DrawingModal-toolbar-left,
  .DrawingModal-toolbar-right {
    width: 100%;
  }

  .DrawingModal-toolbar-right {
    justify-content: stretch;
  }

  .DrawingModal-action-btn {
    flex: 1;
  }

  .DrawingModal-color-bar {
    padding: 12px 20px;
  }

  .DrawingModal-canvas-wrapper {
    padding: 16px;
  }

  .DrawingModal-footer {
    padding: 16px 20px;
  }

  .DrawingModal-btn {
    flex: 1;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/DrawingModal.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ,SAAS;AACT;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4CAA4C;EAC5C,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,OAAO;EACP,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,yCAAyC;EACzC,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;EAChD,yDAAyD;EACzD,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,OAAO;EACT;AACF","sourcesContent":["/* 手绘模态框样式 */\n\n/* 背景遮罩 */\n.DrawingModal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: DrawingModal-fadeIn 0.2s ease-out;\n  /* 阻止事件穿透到背后的画布 */\n  pointer-events: auto;\n  touch-action: none;\n}\n\n@keyframes DrawingModal-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* 模态框容器 */\n.DrawingModal-container {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  max-width: 90vw;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: DrawingModal-slideUp 0.3s ease-out;\n  /* 确保容器捕获所有事件 */\n  pointer-events: auto;\n  touch-action: auto;\n}\n\n@keyframes DrawingModal-slideUp {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* 标题栏 */\n.DrawingModal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 2px solid #e9ecef;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px 12px 0 0;\n}\n\n.DrawingModal-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.DrawingModal-close {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  font-size: 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.DrawingModal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: rotate(90deg);\n}\n\n/* 工具栏 */\n.DrawingModal-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.DrawingModal-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.DrawingModal-toolbar-right {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* 工具组 */\n.DrawingModal-tool-group {\n  display: flex;\n  gap: 8px;\n}\n\n.DrawingModal-tool-btn {\n  padding: 8px 16px;\n  border: 2px solid #dee2e6;\n  background: #ffffff;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.DrawingModal-tool-btn:hover {\n  border-color: #667eea;\n  background: #f0f4ff;\n  transform: translateY(-1px);\n}\n\n.DrawingModal-tool-btn-active {\n  border-color: #667eea;\n  background: #667eea;\n  color: white;\n}\n\n/* 滑块组 */\n.DrawingModal-slider-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 150px;\n}\n\n.DrawingModal-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.DrawingModal-slider {\n  width: 100%;\n  height: 6px;\n  border-radius: 3px;\n  background: #e9ecef;\n  outline: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.DrawingModal-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #667eea;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.DrawingModal-slider::-webkit-slider-thumb:hover {\n  background: #5568d3;\n  transform: scale(1.2);\n}\n\n.DrawingModal-slider::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #667eea;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.DrawingModal-slider::-moz-range-thumb:hover {\n  background: #5568d3;\n  transform: scale(1.2);\n}\n\n/* 操作按钮 */\n.DrawingModal-action-btn {\n  padding: 8px 14px;\n  border: none;\n  background: #6c757d;\n  color: white;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.DrawingModal-action-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.DrawingModal-action-btn-danger {\n  background: #dc3545;\n}\n\n.DrawingModal-action-btn-danger:hover {\n  background: #c82333;\n}\n\n.DrawingModal-action-btn-success {\n  background: #28a745;\n}\n\n.DrawingModal-action-btn-success:hover {\n  background: #218838;\n}\n\n/* 颜色栏 */\n.DrawingModal-color-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 24px;\n  background: #ffffff;\n  border-bottom: 1px solid #e9ecef;\n  flex-wrap: wrap;\n}\n\n.DrawingModal-color-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.DrawingModal-color-picker {\n  width: 50px;\n  height: 32px;\n  border: 2px solid #dee2e6;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.DrawingModal-color-picker:hover {\n  border-color: #667eea;\n  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);\n}\n\n/* 预设颜色 */\n.DrawingModal-preset-colors {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.DrawingModal-preset-color {\n  width: 28px;\n  height: 28px;\n  border: 2px solid transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.DrawingModal-preset-color:hover {\n  transform: scale(1.15);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.DrawingModal-preset-color-active {\n  border-color: #667eea !important;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);\n  transform: scale(1.1);\n}\n\n/* 画布容器 */\n.DrawingModal-canvas-wrapper {\n  padding: 24px;\n  background: #f8f9fa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  flex: 1;\n  /* 确保画布区域可以正常绘制 */\n  pointer-events: auto;\n  touch-action: none;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n.DrawingModal-canvas-container {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #ffffff;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);\n}\n\n.DrawingModal-text-capture {\n  position: absolute;\n  inset: 0;\n  cursor: text;\n  background: transparent;\n  z-index: 10;\n}\n\n.DrawingModal-text-annotation {\n  position: absolute;\n  cursor: text;\n  font-weight: 600;\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-width: 90%;\n  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  pointer-events: auto;\n  z-index: 20;\n}\n\n.DrawingModal-text-annotation:hover {\n  text-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);\n}\n\n.DrawingModal-text-input {\n  position: absolute;\n  min-width: 140px;\n  max-width: 90%;\n  min-height: 40px;\n  padding: 8px 10px;\n  border: 2px solid rgba(102, 126, 234, 0.6);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.95);\n  outline: none;\n  resize: none;\n  line-height: 1.4;\n  box-shadow: 0 6px 18px rgba(102, 126, 234, 0.25);\n  font-family: \"PingFang SC\", \"Microsoft YaHei\", sans-serif;\n  z-index: 30;\n}\n\n.DrawingModal-text-input::placeholder {\n  color: rgba(73, 80, 87, 0.6);\n}\n\n/* 底部按钮栏 */\n.DrawingModal-footer {\n  display: flex;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 2px solid #e9ecef;\n  background: #ffffff;\n  border-radius: 0 0 12px 12px;\n  justify-content: flex-end;\n}\n\n.DrawingModal-btn {\n  padding: 12px 28px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.DrawingModal-btn-cancel {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.DrawingModal-btn-cancel:hover {\n  background: #dee2e6;\n  transform: translateY(-1px);\n}\n\n.DrawingModal-btn-save {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.DrawingModal-btn-save:hover {\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);\n  transform: translateY(-2px);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .DrawingModal-container {\n    max-width: 95vw;\n    max-height: 95vh;\n  }\n\n  .DrawingModal-header {\n    padding: 16px 20px;\n  }\n\n  .DrawingModal-title {\n    font-size: 18px;\n  }\n\n  .DrawingModal-toolbar {\n    padding: 12px 20px;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .DrawingModal-toolbar-left,\n  .DrawingModal-toolbar-right {\n    width: 100%;\n  }\n\n  .DrawingModal-toolbar-right {\n    justify-content: stretch;\n  }\n\n  .DrawingModal-action-btn {\n    flex: 1;\n  }\n\n  .DrawingModal-color-bar {\n    padding: 12px 20px;\n  }\n\n  .DrawingModal-canvas-wrapper {\n    padding: 16px;\n  }\n\n  .DrawingModal-footer {\n    padding: 16px 20px;\n  }\n\n  .DrawingModal-btn {\n    flex: 1;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
